import { useTurnOffItemTime } from './useTurnOffItemTime';
import { useTurnOffCustomizationLang } from './useTurnOffCustomizationLang';

import type { ITurnOffItemTime } from 'features/menu-page/domain';

export function useTurnOffCustomization(props: Props) {
  const { turnOffCTA } = props;

  const turnOffItemTime = useTurnOffItemTime({ turnOffCTA });

  const lang = useTurnOffCustomizationLang();

  return {
    lang,
    ...turnOffItemTime,
  };
}

interface Props {
  turnOffCTA: (p: ITurnOffItemTime) => void;
}
